import React, { Component } from 'react';
import { PnkHtmlForm } from '../../../pnk-react/pnk-controls/pnk-html-form';
import PnkImage from '../../../pnk-react/pnk-ctrl/pnk-image'


export default class OrganizerForm extends Component {
    // constructor(props) {
    //     super(props)
    // }

    render() {
        return (
            <div>
                <div class="add-organizer-form-main">
                    {/* <div class="form-back-link" onClick={() => this.props.HandleRouting('home')}>
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <a>Back</a>
        </div>  */}
                    <div className="add-organizer-form-main-div">


                        <div class="container-fluid">
                            <h3>{this.props.mystate.showButtonType}</h3>

                            <PnkHtmlForm id="frmOrganizerEntry" onsubmit={this.props.SaveOrganizerEntryData} submitbtn="btnOrganizerEntry" style={{ marginTop: '20px' }}>
                                <div className="edit-btn-div" style={{ display: this.props.mystate.showEditBtn }}>
                                    <button type="button" variant="light" className="profile-entry-cancel-btn btn" onClick={() => this.props.ShowEditMode()}>Edit</button>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Organizer Name</label>
                                            <input type="text" class="form-control form2-control-ausi"
                                                id="txtOrganizerName"
                                                name="txtOrganizerName"
                                                placeholder="Organizer Name"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtOrganizerName}
                                                value={this.props.mystate.txtOrganizerName}
                                                onBlur={this.props.HandleOrganizerInput}
                                                pnkdisplayerrormsg="Invalid Organizer Name"

                                            />
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Organizer Email</label>
                                            <input type="text" class="form-control form2-control-ausi" id="txtOrganizerEmail"
                                                name="txtOrganizerEmail"
                                                placeholder="Email"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtOrganizerEmail}
                                                value={this.props.mystate.txtOrganizerEmail}
                                                onBlur={this.props.HandleOrganizerInput}
                                                pnkdisplayerrormsg="Invalid Email"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Mobile Number</label>
                                            <input type="text" class="form-control form2-control-ausi" id="txtOrganizerMobile"
                                                name="txtOrganizerMobile"
                                                placeholder="Mobile Number"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtOrganizerMobile}
                                                value={this.props.mystate.txtOrganizerMobile}
                                                onBlur={this.props.HandleOrganizerInput}
                                                pnkdisplayerrormsg="Invalid Mobile Number"
                                            />
                                        </div>
                                    </div>
                                </div>


                                <div class="row">

                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Address</label>
                                            <input type="text" class="form-control form2-control-ausi" id="txtOrganizerAddress"
                                                name="txtOrganizerAddress"
                                                placeholder="Address"
                                                //   pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtOrganizerAddress}
                                                value={this.props.mystate.txtOrganizerAddress}
                                                onBlur={this.props.HandleOrganizerInput}
                                            //  pnkdisplayerrormsg="Invalid Organizer Address"
                                            />
                                        </div>
                                    </div>

                                    {/*  <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Designation</label>
                                            <input type="text" class="form-control form2-control-ausi" id="txtOrganizerDesignation"
                                                name="txtOrganizerDesignation"
                                                placeholder="Designation"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtOrganizerDesignation}
                                                value={this.props.mystate.txtOrganizerDesignation}
                                                onBlur={this.props.HandleOrganizerInput}
                                                pnkdisplayerrormsg="Invalid Organizer Designation"

                                            />
                                        </div>
    </div>  */}

                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Category</label>
                                            <select class="custom-select mr-sm-2 form2-control-ausi"
                                                id="ddlOrganizerCategory"
                                                name="ddlOrganizerCategory"
                                                //placeholder="Event Name"
                                                pnkvalidate="forceselect"
                                                pnkvalue={this.props.editDataObj.ddlOrganizerCategory}
                                                value={this.props.mystate.ddlOrganizerCategory}
                                                onChange={this.props.HandleOrganizerInput}
                                                pnkdisplayerrormsg="Select Category" >
                                               
                                                    <option value=''>Select Category</option>
                                            
                                               
                                                {this.props.categorylist.length > 0 ?
                                                    this.props.categorylist.map((item, i) => (
                                                        item.status === 1 || item.status === '1' ?
                                                            <option value={item.category_name}>{item.category_name}</option>
                                                            : ''
                                                    ))
                                                    : ''}
                                            </select>
                                        </div>
                                    </div>


                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group kinship-img-file" id="kinship-img-file">
                                            <label for="exampleFormControlInput1">Upload Avatar</label>
                                            <PnkImage
                                                class="form-control form2-control-ausi" id="fileOrganizerImage"
                                                onChange={this.props.HandleOrganizerInput}
                                                destinationFolder="application/public/images/uploads/kinship/organizers"
                                                allowedTypeStr="png,jpg,jpeg,pdf"
                                                btnPreviewText="Upload Organizer Image"
                                                multiple="false"
                                                limitFiles="1"

                                                name="fileOrganizerImage"
                                                id="fileOrganizerImage"

                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.fileOrganizerImage}
                                                value={this.props.mystate.fileOrganizerImage}
                                                mode={this.props.mystate.mode}
                                                renderChild={this.props.mystate.renderChild}
                                                previewImageSrc={this.props.editDataObj.fileOrganizerImage}
                                                pnkdisplayerrormsg="Invalid Organizer Image"
                                                itemStyle="height:150px;text-align:center"
                                            />
                                        </div>
                                    </div>



                                </div>
                                <div class="row">

                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Description</label>
                                            <textarea class="form-control form2-control-ausi" id="txtOrganizerDescription"
                                                name="txtOrganizerDescription" rows="3"
                                                placeholder="Description"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtOrganizerDescription}
                                                value={this.props.mystate.txtOrganizerDescription}
                                                onBlur={this.props.HandleOrganizerInput}
                                                pnkdisplayerrormsg="Invalid Organizer Description"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Status</label>
                                            <select class="custom-select mr-sm-2 form2-control-ausi"
                                                id="ddlOrganizerStatus"
                                                name="ddlOrganizerStatus"
                                                //placeholder="Event Name"
                                                // pnkvalidate="forceselect"
                                                pnkvalue={this.props.editDataObj.ddlOrganizerStatus}
                                                value={this.props.mystate.ddlOrganizerStatus}
                                                onChange={this.props.HandleOrganizerInput} >
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/*  <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Rating</label>
                                            <input type="text" class="form-control form2-control-ausi" id="txtOrganizerRating"
                                                name="txtOrganizerRating"
                                                placeholder="Rating"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtOrganizerRating}
                                                value={this.props.mystate.txtOrganizerRating}
                                                onBlur={this.props.HandleOrganizerInput}
                                                pnkdisplayerrormsg="Invalid Organizer Rating" />
                                        </div>
    </div>   */}



                                </div>

                                <button class="btn add-organizer-btn pnkvalidatesubmit" id="btnOrganizerEntry" name="save" onClick={() => this.props.SaveOrganizerEntryData} >{this.props.mystate.showButtonType}</button>
                            </PnkHtmlForm>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}